import React from "react";
import { Divider } from "antd";
import {
  CasesByPetitionerLawfirmInstitutionOutcomeChart,
  CasesByPetitionerLawfirmFWDOutcomeChart,
  CasesByPatentOwnerLawfirmInstitutionOutcomeChart,
  CasesByPatentOwnerLawfirmFWDOutcomeChart
} from "./charts";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const CaseTabCounsel = props => {
  const q = keepOnlyPTABQueryStrings(props.location.query);
  const navigateToCaseList = k => v =>
    props.router.push({
      pathname: "/ptab/caselist",
      query: { ...q, [k]: v.key }
    });
  const callToClick = <a>Click to View Cases</a>;
  return (
    <div>
      <CasesByPetitionerLawfirmFWDOutcomeChart query={q} onValueClick={navigateToCaseList("lawfirms.petitioner")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByPetitionerLawfirmInstitutionOutcomeChart query={q} onValueClick={navigateToCaseList("lawfirms.petitioner")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByPatentOwnerLawfirmFWDOutcomeChart query={q} onValueClick={navigateToCaseList("lawfirms.patent_owner")} tooltipExtraRow={callToClick} />
      <Divider />
      <CasesByPatentOwnerLawfirmInstitutionOutcomeChart query={q} onValueClick={navigateToCaseList("lawfirms.patent_owner")} tooltipExtraRow={callToClick} />
    </div>
  );
};

export default CaseTabCounsel;
